import React from 'react';
export default function usePrevious(value) {
    var ref = React.useRef(value);
    React.useEffect(function() {
        ref.current = value;
    });
    return ref.current;
}
